// extracted by mini-css-extract-plugin
export default {"mn-waterfall-image-detail-info":"index_mn-waterfall-image-detail-info__lJy1d"};